import { Link } from "react-router-dom"
import { computed } from "mobx"
import { observer } from "mobx-react"
import { Button, Flex, Form, Input, Typography } from "antd"
import { CopyOutlined } from "@ant-design/icons"

import icon from "@src/app/assets/icons/success-status.svg"
import { notify } from "@src/app/components/notify"
import { paths } from "@src/app/paths"
import { InvoiceEntity } from "@src/pages/paymentLinksCreate/classes/InvoiceEntity"
import css from "../index.module.css"

type Props = {
  invoice: InvoiceEntity
  paymentPageUrl?: string
}
export const InvoiceCreateSuccess = observer(
  ({ invoice, paymentPageUrl }: Props) => {
    const invoiceUrl = computed(
      () => `${paymentPageUrl}/invoice/${invoice.state.id}`,
    ).get()

    const copyShareLink = () => {
      navigator.clipboard.writeText(invoiceUrl)
      notify.success("Copied")
    }

    const emailLink = computed(() => {
      const { customer_email, customer_name, id } = invoice.state
      return decodeURI(
        `mailto:${customer_email}?subject=Invoice%20${id}&amp;body=Dear%20${customer_name},%20You%20can%20view%20and%20pay%20for%20your%20invoice%20by%20clicking%20the%20link%20below.%0D${invoiceUrl}`,
      )
    }).get()

    return (
      <Flex
        align="center"
        gap={48}
        style={{
          backgroundColor: "#fff",
          borderRadius: 12,
          padding: "48px 24px 24px 24px",
        }}
        vertical
      >
        <img alt="success" src={icon} />

        <Flex align="center" gap={24} vertical>
          <div style={{ textAlign: "center" }}>
            <Typography.Title level={3}>Payment link created</Typography.Title>

            <Typography.Text>
              You can send the payment link via email or any other convenient
              method.
            </Typography.Text>
          </div>

          <Form.Item
            id="GENERATED_ID_INVOICECREATESUCCESS_TSX_FORM.ITEM_VOID_1"
            label="Payment Link"
            layout="vertical"
            style={{ width: "75%" }}
          >
            <Input
              addonAfter={
                <Button
                  icon={<CopyOutlined />}
                  id="GENERATED_ID_INVOICECREATESUCCESS_BUTTON_VOID_1"
                  onClick={copyShareLink}
                  size="small"
                  type="text"
                ></Button>
              }
              className={css.urlInput}
              disabled
              value={invoiceUrl}
            />
          </Form.Item>
        </Flex>

        <Flex align={"center"} gap={16}>
          <Link
            id="GENERATED_ID_INVOICECREATESUCCESS_LINK_VOID_1"
            to={paths.paymentLinks}
          >
            <Button
              block
              id="GENERATED_ID_INVOICECREATESUCCESS_BUTTON_RETURN_TO_DASHBOARD_1"
              size="large"
            >
              Return to Dashboard
            </Button>
          </Link>
          <Button
            block
            href={emailLink}
            id="GENERATED_ID_INVOICECREATESUCCESS_BUTTON_SEND_BY_EMAIL_1"
            size="large"
            type="primary"
          >
            Send by email
          </Button>
        </Flex>
      </Flex>
    )
  },
)
